import { apiClient } from './client';

export interface LoginDTO {
  email: string;
  password: string;
}

export interface RegisterDTO {
  email: string;
  password: string;
  role?: string;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
}

export const authApi = {
  login: (data: LoginDTO): Promise<AuthResponse> =>
    apiClient.post<AuthResponse>('/auth/login', data),
  register: (data: RegisterDTO): Promise<AuthResponse> =>
    apiClient.post<AuthResponse>('/auth/register', data),
};


